













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GSubTitleBar',
  computed: {},
  methods: {},
})
export default class GSubTitleBar extends Vue {
  mounted() {}
}
